import React from "react";
import ReactQuill from "react-quill";

import "react-quill/dist/quill.snow.css";

export const TextEditor = ({ value, onChange, placeholder = "Content goes here...", label, id, testId = "text-editor" }) => {
  return (
    <div className="my-4">
      <label className="mb-2 block text-sm font-medium leading-6 text-gray-900" htmlFor={id}>
        {label}
      </label>
      <ReactQuill data-testid={testId} id={id} theme="snow" placeholder={placeholder} value={value} onChange={onChange} />
    </div>
  );
};
